<template>
  <div class="insurancePolicyManagement-container">
    <div>
      <el-form inline :model="queryForm" ref="queryForm" size="medium">
        <el-form-item class="r-20" prop="plateNum">
          <el-input
            v-model.trim="queryForm.plateNum"
            placeholder="车牌号"
            @keyup.enter.native="query"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="vin">
          <el-input
            v-model.trim="queryForm.vin"
            placeholder="车架号"
            @keyup.enter.native="query"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="propertyOwner">
          <el-select
            v-model.trim="queryForm.propertyOwner"
            placeholder="请选择产权方"
          >
            <el-option
              v-for="item in ownershipName"
              :key="item.id"
              :label="item.value"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="r-20" prop="personnelName">
          <el-input
            v-model.trim="queryForm.personnelName"
            placeholder="车辆绑定人"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="companyName">
          <el-autocomplete
            v-model.trim="queryForm.companyName"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入保险公司"
            :popper-append-to-body="false"
            style="width: 100%"
            clearable
            @keyup.enter.native="query"
          >
            <!--  解决匹配不到提示无匹配数据 -->
            <template v-if="noData" slot-scope="{ item }">
              <div class="default">{{ item.default }}</div>
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button @click="reset">取消</el-button>
      </el-form>
      <el-table
        :data="tableData"
        size="mini"
        stripe
        height="560px"
        @sort-change="remainingTimeSort"
      >
        <el-table-column width="20"></el-table-column>
        <el-table-column label="序号" type="index" width="40"></el-table-column>
        <el-table-column
          label="车牌号"
          prop="plateNum"
          min-width="70"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="车架号"
          prop="vin"
          min-width="140"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="产权方"
          prop="propertyOwner"
          min-width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="车辆绑定人"
          prop="personnelName"
          min-width="80"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="联系电话"
          prop="phone"
          min-width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="保险公司"
          prop="companyName"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="交强险生效日期"
          prop="effectiveDate"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="商业险生效日期"
          prop="businessDate"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="交强险到期剩余（天）"
          prop="effectiveCountdown"
          min-width="190"
          show-overflow-tooltip
          sortable="custom"
        >
          <template slot-scope="{ row }">
            <div :class="changeTime(row.effectiveCountdown)">
              {{ row.effectiveCountdown }}
            </div>
          </template>
          <template slot="header">
            <span>交强险到期剩余（天）</span>
            <i
              class="iconfont"
              :class="[
                top ? 'icon-paixushengxu' : 'icon-paixujiangxu',
                { paixuBlue: isPaixuBlue },
              ]"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="商业险到期剩余（天）"
          prop="businessCountdown"
          min-width="190"
          show-overflow-tooltip
          sortable="custom"
        >
          <template slot-scope="{ row }">
            <div :class="changeTime(row.businessCountdown)">
              {{ row.businessCountdown }}
            </div>
          </template>
          <template slot="header">
            <span>商业险到期剩余（天）</span>
            <i
              class="iconfont"
              :class="[
                businessTop ? 'icon-paixushengxu' : 'icon-paixujiangxu',
                { paixuBlue: isPaixuBusiness },
              ]"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" min-width="280">
          <template slot-scope="{ row }">
            <el-button type="text" @click.stop="queryDriver(row)"
              >查看行驶证</el-button
            >
            <el-button type="text" @click="updatePolicy(row)"
              >更新保单</el-button
            >
            <el-button type="text" @click="watchPolicy(row)"
              >当前保单</el-button
            >
            <el-button type="text" @click="historyPolicy(row)"
              >历史保单</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 行驶证弹窗 -->
      <el-dialog
        title="行驶证"
        :visible.sync="driverVisible"
        class="mini-dialog driverBody"
      >
        <p class="dialog-title">车辆照片页</p>
        <div class="imgWrap" style="padding-bottom: 10px">
          <el-image :src="vehicleUrl" :preview-src-list="vehicleUrlList">
            <div slot="error" class="errorImg">未上传</div>
          </el-image>
        </div>
        <p class="dialog-title">行驶证主页</p>
        <div class="imgWrap" style="padding-bottom: 10px">
          <el-image :src="mainPageUrl" :preview-src-list="mainPageUrlList">
            <div slot="error" class="errorImg">未上传</div>
          </el-image>
        </div>
        <p class="dialog-title">行驶证副页</p>
        <div class="imgWrap" style="padding-bottom: 10px">
          <el-image :src="vicePageUrl" :preview-src-list="vicePageUrlList">
            <div slot="error" class="errorImg">未上传</div>
          </el-image>
        </div>
      </el-dialog>

      <!-- 更新保单 -->
      <el-dialog
        title="更新保单"
        class="policy-dialog"
        :visible.sync="policyVisible"
        @close="cancelDialog"
      >
        <el-form
          inline
          :model="policyForm"
          :rules="policyRules"
          ref="policyForm"
        >
          <el-form-item class="r-20" label="保险公司" prop="companyName">
            <el-select
              v-model.trim="policyForm.companyName"
              placeholder="请选择保险公司"
            >
              <el-option
                v-for="item in companyList"
                :key="item.id"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="交强险生效日期" prop="effectiveDate">
            <el-date-picker
              v-model.trim="policyForm.effectiveDate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择保险生效日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="商业险生效日期" prop="businessDate">
            <el-date-picker
              v-model.trim="policyForm.businessDate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择保险生效日期"
            >
            </el-date-picker>
          </el-form-item>
          <div class="policy-item">
            <el-form-item
              label="交强险保单（支持最大上传1个PDF文件，单个文件最大不超过20MB）："
              label-width="100%"
              prop="compulsoryInsurance"
              class="trafficPdfUpload"
            >
              <el-upload
                action="/api/vehicle/insurance/company/insuranceFileUpload"
                accept=".pdf"
                list-type="picture-card"
                :auto-upload="true"
                :before-upload="uploadFile"
                :on-success="handleTrafficChange"
                :class="policyForm.compulsoryInsurance ? 'myUpload' : ''"
              >
                <el-button type="text">{{
                  policyForm.compulsoryInsurance ? renew : policyText
                }}</el-button>
              </el-upload>
              <div
                class="imgWrap"
                v-if="policyForm.compulsoryInsurance"
                @click="previewTrafficPdf"
              >
                <vue-pdf-embed :source="policyForm.compulsoryInsurance" />
                <!-- <pdf :src="trafficPolicySrc"></pdf> -->
                <el-dialog
                  :visible.sync="iframeTrafficVisible"
                  append-to-body
                  title="预览/下载 pdf"
                >
                  <iframe
                    :src="policyForm.compulsoryInsurance"
                    frameborder="0"
                    style="width: 100%; height: 800px"
                  ></iframe>
                </el-dialog>
              </div>
            </el-form-item>
          </div>
          <div class="policy-item">
            <el-form-item
              label="商业险保单（支持最大上传1个PDF文件，单个文件最大不超过20MB）："
              label-width="100%"
              prop="commercialInsurance"
              class="trafficPdfUpload"
            >
              <el-upload
                action="/api/vehicle/insurance/company/insuranceFileUpload"
                list-type="picture-card"
                :auto-upload="true"
                accept=".pdf"
                :before-upload="uploadFile"
                :on-success="handleCommercialChange"
                :class="policyForm.commercialInsurance ? 'myUpload' : ''"
              >
                <el-button type="text">{{
                  policyForm.commercialInsurance ? renew : policyText
                }}</el-button>
              </el-upload>
              <div
                class="imgWrap"
                v-if="policyForm.commercialInsurance"
                @click="previewCommercialPdf"
              >
                <vue-pdf-embed :source="policyForm.commercialInsurance" />
                <!-- <pdf :src="commercialPolicySrc"></pdf> -->
                <el-dialog
                  :visible.sync="iframeCommercialVisible"
                  append-to-body
                  title="预览/下载 pdf"
                >
                  <iframe
                    :src="policyForm.commercialInsurance"
                    frameborder="0"
                    style="width: 100%; height: 800px"
                  ></iframe>
                </el-dialog>
              </div>
            </el-form-item>
          </div>
          <div class="policy-item">
            <el-form-item
              label="保险发票（支持最大上传一张照片或者一个PDF文件，单个照片最大不超过10MB，单个文件最大不超过20MB）："
              label-width="100%"
              class="trafficPdfUpload"
            >
              <!-- <p class="dialog-title">保险发票</p> -->
              <el-upload
                action="/api/vehicle/insurance/company/insuranceFileUpload"
                list-type="picture-card"
                :auto-upload="true"
                :before-upload="(file) => uploadImage(file, 1)"
                :on-success="onChangeBill1"
                :class="policyForm.invoicePhoto1 ? 'myUpload' : ''"
              >
                <el-button type="text">{{
                  policyForm.invoicePhoto1 ? renew : policyBillText1
                }}</el-button>
              </el-upload>
              <div class="imgWrap">
                <el-image
                  v-if="policyForm.invoicePhoto1"
                  :src="policyForm.invoicePhoto1"
                  :preview-src-list="[policyForm.invoicePhoto1]"
                >
                  <div slot="error">未上传</div>
                </el-image>
              </div>

              <el-upload
                action="/api/vehicle/insurance/company/insuranceFileUpload"
                list-type="picture-card"
                :auto-upload="true"
                :before-upload="(file) => uploadImage(file, 2)"
                :on-success="onChangeBill2"
                :class="policyForm.invoicePhoto2 ? 'myUpload' : ''"
              >
                <el-button type="text">{{
                  policyForm.invoicePhoto2 ? renew : policyBillText2
                }}</el-button>
              </el-upload>
              <div class="imgWrap">
                <el-image
                  v-if="policyForm.invoicePhoto2"
                  :src="policyForm.invoicePhoto2"
                  :preview-src-list="[policyForm.invoicePhoto2]"
                >
                  <div slot="error">未上传</div>
                </el-image>
              </div>

              <el-upload
                action="/api/vehicle/insurance/company/insuranceFileUpload"
                list-type="picture-card"
                :auto-upload="true"
                accept=".pdf"
                :before-upload="uploadFile"
                :on-success="handleBillChange1"
                :class="policyForm.invoicePdf1 ? 'myUpload' : ''"
              >
                <el-button type="text">{{
                  policyForm.invoicePdf1 ? renew : policyBillPdfText1
                }}</el-button>
              </el-upload>
              <div
                class="imgWrap"
                v-if="policyForm.invoicePdf1"
                @click="previewBillPdf(1)"
              >
                <vue-pdf-embed :source="policyForm.invoicePdf1" />
                <!-- <pdf :src="billPolicySrc"></pdf> -->
                <el-dialog
                  :visible.sync="iframeBillVisible1"
                  append-to-body
                  title="预览/下载 pdf"
                >
                  <iframe
                    :src="policyForm.invoicePdf1"
                    frameborder="0"
                    style="width: 100%; height: 800px"
                  ></iframe>
                </el-dialog>
              </div>

              <el-upload
                action="/api/vehicle/insurance/company/insuranceFileUpload"
                list-type="picture-card"
                :auto-upload="true"
                accept=".pdf"
                :before-upload="uploadFile"
                :on-success="handleBillChange2"
                :class="policyForm.invoicePdf2 ? 'myUpload' : ''"
              >
                <el-button type="text">{{
                  policyForm.invoicePdf2 ? renew : policyBillPdfText2
                }}</el-button>
              </el-upload>
              <div
                class="imgWrap"
                v-if="policyForm.invoicePdf2"
                @click="previewBillPdf(2)"
              >
                <vue-pdf-embed :source="policyForm.invoicePdf2" />
                <!-- <pdf :src="billPolicySrc"></pdf> -->
                <el-dialog
                  :visible.sync="iframeBillVisible2"
                  append-to-body
                  title="预览/下载 pdf"
                >
                  <iframe
                    :src="policyForm.invoicePdf2"
                    frameborder="0"
                    style="width: 100%; height: 800px"
                  ></iframe>
                </el-dialog>
              </div>
              <!-- <div class="imgWrap">
            <el-image
              v-if="policyBillPdf"
              :src="policyBillPdf.url"
              :preview-src-list="[policyBillPdf.url]"
            >
            </el-image>
          </div> -->
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveUpload">确认上传</el-button>
          <el-button @click="cancelUpload">取消</el-button>
        </span>
      </el-dialog>

      <!-- 当前保单查看 -->
      <el-dialog
        title="当前保单"
        class="watch-policy-dialog"
        :visible.sync="watchPolicyVisible"
      >
        <el-row class="modify" v-show="!editorFlag">
          <el-button type="primary" @click="editorPdf">编辑</el-button>
        </el-row>
        <div class="modify" v-show="editorFlag">
          <el-button type="primary" @click="saveUpload">保 存</el-button>
          <el-button @click="cancelUpload">取 消</el-button>
        </div>
        <el-form
          v-show="editorFlag"
          inline
          :model="policyForm"
          :rules="policyRules"
          ref="policyForm"
        >
          <el-form-item class="r-20" label="保险公司" prop="companyName">
            <el-select
              v-model.trim="policyForm.companyName"
              placeholder="请选择保险公司"
            >
              <el-option
                v-for="item in companyList"
                :key="item.id"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="交强险生效日期" prop="effectiveDate">
            <el-date-picker
              v-model.trim="policyForm.effectiveDate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择保险生效日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="商业险生效日期" prop="businessDate">
            <el-date-picker
              v-model.trim="policyForm.businessDate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择保险生效日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <el-row v-show="!editorFlag">
          <el-col :span="8">
            <el-col :span="8">保险公司：</el-col>
            <el-col :span="16">{{
              $judgeEmpty(policyForm.companyName)
            }}</el-col>
          </el-col>
          <!-- <el-col :span="4"></el-col> -->
          <el-col :span="8">
            <el-col :span="10">交强险生效日期：</el-col>
            <el-col :span="14">{{
              $judgeEmpty(policyForm.effectiveDate)
            }}</el-col>
          </el-col>
          <el-col :span="8">
            <el-col :span="10">商业险生效日期：</el-col>
            <el-col :span="14">{{
              $judgeEmpty(policyForm.businessDate)
            }}</el-col>
          </el-col>
        </el-row>
        <el-row class="watch-item">
          <el-row class="item-top">
            <el-col :span="4">
              <p class="dialog-title" :class="editorFlag ? 'require' : null">
                交强险保单
              </p>
            </el-col>
            <el-col :span="16">
              <el-button
                v-show="!editorFlag"
                type="primary"
                @click="exportData(policyForm.compulsoryInsurance, true)"
                >导出</el-button
              >
              <el-upload
                v-show="editorFlag"
                action="/api/vehicle/insurance/company/insuranceFileUpload"
                accept=".pdf"
                list-type="picture-card"
                :auto-upload="true"
                :before-upload="uploadFile"
                :on-success="handleTrafficChange"
                class="reset-upload"
              >
                <el-button type="primary">{{
                  policyForm.compulsoryInsurance ? renew : uploadText
                }}</el-button>
              </el-upload>
            </el-col>
          </el-row>
          <el-row class="item-bottom">
            <div
              class="imgWrap"
              v-if="policyForm.compulsoryInsurance"
              @click="previewTrafficPdf"
            >
              <vue-pdf-embed :source="policyForm.compulsoryInsurance" />
              <!-- <pdf :src="trafficPolicySrc"></pdf> -->
              <el-dialog
                :visible.sync="iframeTrafficVisible"
                append-to-body
                title="预览/下载 pdf"
              >
                <iframe
                  :src="policyForm.compulsoryInsurance"
                  frameborder="0"
                  style="width: 100%; height: 800px"
                ></iframe>
              </el-dialog>
            </div>
          </el-row>
        </el-row>
        <el-row class="watch-item">
          <el-row class="item-top">
            <el-col :span="4">
              <p class="dialog-title">商业险保单</p>
            </el-col>
            <el-col :span="16">
              <el-button
                v-show="!editorFlag"
                type="primary"
                @click="exportData(policyForm.commercialInsurance, true)"
                >导出</el-button
              >
              <el-upload
                v-show="editorFlag"
                action="/api/vehicle/insurance/company/insuranceFileUpload"
                accept=".pdf"
                list-type="picture-card"
                :auto-upload="true"
                :before-upload="uploadFile"
                :on-success="handleCommercialChange"
                class="reset-upload"
              >
                <el-button type="primary">{{
                  policyForm.commercialInsurance ? renew : uploadText
                }}</el-button>
              </el-upload>
            </el-col>
          </el-row>
          <el-row class="item-bottom">
            <div
              class="imgWrap"
              v-if="policyForm.commercialInsurance"
              @click="previewCommercialPdf"
            >
              <vue-pdf-embed :source="policyForm.commercialInsurance" />
              <el-dialog
                :visible.sync="iframeCommercialVisible"
                append-to-body
                title="预览/下载 pdf"
              >
                <iframe
                  :src="policyForm.commercialInsurance"
                  frameborder="0"
                  style="width: 100%; height: 800px"
                ></iframe>
              </el-dialog>
            </div>
          </el-row>
        </el-row>
        <el-row class="watch-item">
          <el-row class="item-top">
            <el-col :span="4">
              <p class="dialog-title">保险发票</p>
            </el-col>
            <el-col :span="16">
              <el-button
                style="margin-right:20px"
                v-if="policyForm.invoicePdf && !editorFlag"
                type="primary"
                @click="exportData(policyForm.invoicePdf, true)"
                >导出PDF</el-button
              >
              <el-upload
                v-show="editorFlag"
                action="/api/vehicle/insurance/company/insuranceFileUpload"
                list-type="picture-card"
                :auto-upload="true"
                accept=".pdf"
                :before-upload="uploadFile"
                :on-success="handleBillChange1"
                class="reset-upload"
              >
                <el-button type="primary">{{
                  policyForm.invoicePdf1 ? renewPdf : policyBillPdfText1
                }}</el-button>
              </el-upload>
              <el-upload
                v-show="editorFlag"
                action="/api/vehicle/insurance/company/insuranceFileUpload"
                list-type="picture-card"
                :auto-upload="true"
                accept=".pdf"
                :before-upload="uploadFile"
                :on-success="handleBillChange2"
                class="reset-upload"
              >
                <el-button type="primary" size="medium ">{{
                  policyForm.invoicePdf2 ? renewPdf : policyBillPdfText2
                }}</el-button>
              </el-upload>

              <el-button
                v-if="policyForm.invoicePhoto && !editorFlag"
                type="primary"
                @click="exportData(policyForm.invoicePhoto, false)"
                >导出图片</el-button
              >
              <el-upload
                v-show="editorFlag"
                action="/api/vehicle/insurance/company/insuranceFileUpload"
                list-type="picture-card"
                :auto-upload="true"
                :before-upload="(file) => uploadImage(file, 1)"
                :on-success="onChangeBill1"
                class="reset-upload"
              >
                <el-button type="primary">{{
                  policyForm.invoicePhoto1 ? renewImg : policyBillText1
                }}</el-button>
              </el-upload>
              <el-upload
                v-show="editorFlag"
                action="/api/vehicle/insurance/company/insuranceFileUpload"
                list-type="picture-card"
                :auto-upload="true"
                :before-upload="(file) => uploadImage(file, 2)"
                :on-success="onChangeBill2"
                class="reset-upload"
              >
                <el-button type="primary">{{
                  policyForm.invoicePhoto2 ? renewImg : policyBillText2
                }}</el-button>
              </el-upload>
            </el-col>
          </el-row>
          <el-row class="item-bottom">
            <el-image
              :src="policyForm.invoicePhoto1"
              style="width: 500px"
              :preview-src-list="[policyForm.invoicePhoto1]"
            >
              <div slot="error">未上传</div>
            </el-image>
            <el-image
              :src="policyForm.invoicePhoto2"
              style="width: 500px"
              :preview-src-list="[policyForm.invoicePhoto2]"
            >
              <div slot="error">未上传</div>
            </el-image>
            <div
              class="imgWrap"
              v-if="policyForm.invoicePdf1"
              @click="previewBillPdf(1)"
            >
              <vue-pdf-embed
                ref="invoicePdf1"
                :source="policyForm.invoicePdf1"
              />
              <!-- <pdf :src="billPolicySrc"></pdf> -->
              <el-dialog
                :visible.sync="iframeBillVisible1"
                append-to-body
                title="预览/下载 pdf"
              >
                <iframe
                  :src="policyForm.invoicePdf1"
                  frameborder="0"
                  style="width: 100%; height: 800px"
                ></iframe>
              </el-dialog>
            </div>
            <div v-else class="el-image">未上传</div>
            <div
              class="imgWrap"
              v-if="policyForm.invoicePdf2"
              @click="previewBillPdf(2)"
            >
              <vue-pdf-embed :source="policyForm.invoicePdf2" />
              <!-- <pdf :src="billPolicySrc"></pdf> -->
              <el-dialog
                :visible.sync="iframeBillVisible2"
                append-to-body
                title="预览/下载 pdf"
              >
                <iframe
                  :src="policyForm.invoicePdf2"
                  frameborder="0"
                  style="width: 100%; height: 800px"
                ></iframe>
              </el-dialog>
            </div>
            <div v-else class="el-image">未上传</div>
          </el-row>
        </el-row>
      </el-dialog>

      <!-- 历史保单查看 -->
      <el-dialog
        title="历史保单"
        class="history-policy-dialog"
        :visible.sync="historyPolicyVisible"
      >
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            v-for="item in historyList"
            :key="item.id"
            :label="item.effectiveDate"
            :name="item.effectiveDate"
          >
            <el-button
              class="delete-button"
              type="danger"
              @click="delData(item.id)"
              >删除</el-button
            >
            <history-policy
              v-if="item.effectiveDate == activeName"
              :historyFormId="item.id"
            ></history-policy>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="limit"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
// import pdf from "vue-pdf-signature";
// import CMapReaderFactory from "vue-pdf-signature/src/CMapReaderFactory.js";
import HistoryPolicy from "@/views/InsurancePolicy/InsurancePolicyManagement/components/HistoryPolicy.vue";
export default {
  name: "InsurancePolicyManagement",
  components: {
    VuePdfEmbed,
    HistoryPolicy,
  },
  data() {
    return {
      queryForm: {
        plateNum: "",
        vin: "",
        propertyOwner: "",
        personnelName: "",
        companyName: "",
        sort: 2,
      },
      policyForm: {
        vin: "",
        commercialInsurance: "", // 商业险保单路径
        compulsoryInsurance: "", // 交强险保单路径
        effectiveDate: "", // 交强险生效日期(年-月-日)
        businessDate: "", // 商业险生效日期(年-月-日)
        companyName: "", // 保险公司
        invoicePdf1: "", // 保险发票pdf
        invoicePdf2: "", // 保险发票pdf
        invoicePhoto1: "", // 保险发票照片
        invoicePhoto2: "", // 保险发票照片
        state: "", // 状态 1:正常， -1:删除
        addTime: "", // 添加时间
      },
      policyRules: {
        companyName: [
          { required: true, trigger: "blur", message: "请选择保险公司" },
        ],
        effectiveDate: [
          { required: true, trigger: "blur", message: "请选择保险生效日期" },
        ],
        compulsoryInsurance: [
          { required: true, trigger: "blur", message: "请上传交强险保单" },
        ],
        // commercialInsurance: [
        //   { required: true, trigger: "blur", message: "请上传商业险保单" },
        // ],
        invoicePdf: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (this.policyForm.invoicePhoto || this.policyForm.invoicePdf) {
                callback();
              } else {
                callback(new Error("请上传保险发票照片或者PDF文件"));
              }
            },
          },
        ],
      },
      tableData: [],
      companyList: [], // 保险公司列表
      top: false,
      businessTop: false,
      isPaixuBlue: false,
      isPaixuBusiness: false,
      driverVisible: false,
      policyVisible: false,
      iframeCommercialVisible: false,
      iframeTrafficVisible: false,
      iframeBillVisible1: false,
      iframeBillVisible2: false,
      watchPolicyVisible: false,
      historyPolicyVisible: false,
      iframeTrafficUrl: "",
      iframeCommercialUrl: "",
      iframeBillUrl: "",
      vehicleUrl: "",
      vehicleUrlList: [],
      mainPageUrl: "",
      mainPageUrlList: [],
      vicePageUrl: "",
      vicePageUrlList: [],
      uploadText: "上传",
      policyText: "上传保单PDF",
      policyBillText1: "上传发票照片①",
      policyBillText2: "上传发票照片②",
      policyBillPdfText1: "上传发票PDF①",
      policyBillPdfText2: "上传发票PDF②",
      renew: "重新上传",
      renewPdf: "重新上传PDF",
      renewImg: "重新上传图片",
      currentPage: 1,
      limit: 10,
      total: 0,
      historyList: [],
      activeName: "",
      ownershipName: {},
      restaurants: [],
      noData: false, // 是否匹配到数据了
      editorFlag: false,
    };
  },
  mounted() {
    this.getCompanyList();
    this.getInsuranceList();
    this.getOwnerNameList().then(() => {
      this.restaurants = this.companyList;
    });
  },
  // computed: {
  //   //解决预览pdf文字丢失Warning: Error during font loading: The CMap “baseUrl“ parameter must be specifie的问题
  //   trafficPolicySrc() {
  //     //处理pdfUrl返回
  //     console.log("77777777777777777777", this.policyForm.compulsoryInsurance);
  //     let src = pdf.createLoadingTask({
  //       url: this.policyForm.compulsoryInsurance,
  //       CMapReaderFactory,
  //     });
  //     console.log("------------------------------", src);
  //     return src;
  //   },
  //   commercialPolicySrc() {
  //     let src = pdf.createLoadingTask({
  //       url: this.policyForm.commercialInsurance,
  //       CMapReaderFactory,
  //     });
  //     return src;
  //   },
  //   billPolicySrc() {
  //     //处理pdfUrl返回
  //     let src = pdf.createLoadingTask({
  //       url: this.policyForm.invoicePdf,
  //       CMapReaderFactory,
  //     });
  //     return src;
  //   },
  // },
  methods: {
    // 编辑保单
    editorPdf() {
      // 打开编辑状态
      this.editorFlag = true;
    },
    querySearchAsync(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;
      this.noData = false;
      if (results.length === 0) {
        results = [{ default: "无此保险公司" }];
        this.noData = true;
      }
      // 调用 callback 返回建议列表的数据
      results.map((item) => {
        return item.value;
      });
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 1000 * Math.random());
    },
    createStateFilter(queryString) {
      return (restaurant) => {
        let restaurants =
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) !==
          -1;
        return restaurants;
      };
    },
    async delData(id) {
      //多选删除
      if (!id) {
        return;
      }
      this.$confirm("确定删除吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let { data: res } = await this.$axios.delete(
          "/api/vehicle/insuranceManage/delete?id=" + id
        );
        if (res.code == 1) {
          this.$message.success("操作成功");
          let totalPage = Math.ceil((this.total - 1) / 10);
          let currentPage =
            this.currentPage > totalPage ? totalPage : this.currentPage;
          this.currentPage = currentPage < 1 ? 1 : currentPage;
          this.getInsuranceList();
          // 关闭历史保单弹框
          this.historyPolicyVisible = false;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 获取产权方名称列表
    async getOwnerNameList() {
      let { data: res } = await this.$axios.get(
        "/api/property/management/getName"
      );
      if (res.code == 1) {
        this.ownershipName = res.data.map((item, index) => {
          return { id: index, value: item };
        });
      } else {
        this.$message.warning(res.msg);
      }
    },
    //数据导出
    exportData(url, type) {
      let _this = this;
      if (!url) {
        return this.$message.warning("请先上传！");
      }
      _this
        .$confirm("确定导出当前数据吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "success",
        })
        .then(async () => {
          url.split(",").forEach((urlSingle) => {
            let name = _this.subString(urlSingle);
            if (type) {
              this.downloadFile(urlSingle, name);
            } else {
              this.downloadImg(urlSingle, name);
            }
          });
        });
    },
    downloadFile(url, fileName) {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = fileName;
          link.target = "_blank"; // 可选，如果希望在新窗口中下载文件，请取消注释此行
          link.click();
        });
    },
    downloadImg(src, name) {
      let image = new Image();
      image.src = src;
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function() {
        let c = document.createElement("canvas");
        c.width = image.width;
        c.height = image.height;
        c.getContext("2d").drawImage(image, 0, 0, image.width, image.height);
        let a = document.createElement("a");
        a.download = name;
        a.href = c.toDataURL("image/jpg");
        a.click();
      };
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 查看当前保单
    watchPolicy(rowData) {
      this.watchPolicyVisible = true;
      this.policyForm = {
        ...rowData,
        invoicePdf1: rowData.invoicePdf && rowData.invoicePdf.split(",")[0],
        invoicePdf2: rowData.invoicePdf && rowData.invoicePdf.split(",")[1],
        invoicePhoto1:
          rowData.invoicePhoto && rowData.invoicePhoto.split(",")[0],
        invoicePhoto2:
          rowData.invoicePhoto && rowData.invoicePhoto.split(",")[1],
      };
      // 重置编辑状态
      this.editorFlag = false;
    },
    // 查看历史保单
    async historyPolicy(rowData) {
      this.activeName = rowData.effectiveDate;
      // 清空文件数据
      this.historyList.forEach((item) => {
        Object.keys(item).forEach((key) => {
          item[key] = null;
        });
      });
      let { data: res } = await this.$axios.get(
        "/api/vehicle/insuranceManage/historicalList",
        {
          params: { vin: rowData.vin },
        }
      );
      if (res.code == 1) {
        this.historyList = res.data;
      } else {
        this.$message.warning(res.msg);
      }
      if (res.data.length > 0) {
        this.historyPolicyVisible = true;
      } else {
        this.$message.warning("未查询到数据！");
      }
    },
    // 预览和下载pdf文件
    previewTrafficPdf() {
      this.iframeTrafficVisible = true;
    },
    previewCommercialPdf() {
      this.iframeCommercialVisible = true;
    },
    previewBillPdf(type) {
      if (type === 2) {
        this.iframeBillVisible2 = true;
      } else {
        this.iframeBillVisible1 = true;
      }
    },
    handleTrafficChange(res) {
      // // 解析pdf文件
      // const reader = new FileReader();
      // reader.onload = (e) => {
      //   this.policyForm.compulsoryInsurance = e.target.result;
      // };
      // reader.readAsDataURL(file.raw);
      // this.iframeTrafficUrl = file.url;
      this.policyForm.compulsoryInsurance = res.data;
    },
    handleCommercialChange(res) {
      // const reader = new FileReader();
      // reader.onload = (e) => {
      //   this.policyForm.commercialInsurance = e.target.result;
      // };
      // reader.readAsDataURL(file.raw);
      // this.iframeCommercialUrl = file.url;
      this.policyForm.commercialInsurance = res.data;
    },
    // 上传发票PDF触发
    handleBillChange1(res) {
      // const reader = new FileReader();
      // reader.onload = (e) => {
      //   this.policyForm.invoicePdf = e.target.result;
      // };
      // reader.readAsDataURL(file.raw);
      // this.iframeBillUrl = file.url;
      this.policyForm.invoicePdf1 = res.data;
    },
    // 上传发票PDF触发
    handleBillChange2(res) {
      this.policyForm.invoicePdf2 = res.data;
    },
    // 上传图片触发
    onChangeBill1(res) {
      console.log(res);
      this.policyForm.invoicePhoto1 = res.data;
    },
    // 上传图片触发
    onChangeBill2(res) {
      this.policyForm.invoicePhoto2 = res.data;
    },
    // 判断上传的是否为pdf文件和限制文件格式、大小等
    uploadFile(file) {
      const pdf = file.name.substring(file.name.lastIndexOf(".") + 1);
      const sizeLength = file.size / 1024 / 1024 < 10;
      if (pdf != "pdf") {
        this.$message.error("请上传正确的PDF文件格式!");
        // 删除当前不满足条件的文件
        return false;
      }
      // 可以限制文件的大小
      if (!sizeLength) {
        this.$message.error("上传文件大小不能超过10MB!");
      }
    },
    // 判断上传的是否为图片和限制图片格式、大小等
    uploadImage(file, type) {
      const img = file.name.substring(file.name.lastIndexOf(".") + 1);
      const sizeLength = file.size / 1024 / 1024 < 10;
      if (img != "jpg" && img != "png" && img != "jpeg") {
        this.$message.error("请上传正确的图片格式!");
        if (type === 2) {
          this.policyForm.invoicePhoto2 = "";
        } else {
          this.policyForm.invoicePhoto1 = "";
        }
        return false;
      }
      // 可以限制图片的大小
      if (!sizeLength) {
        this.$message.error("上传图片大小不能超过10MB!");
        if (type === 2) {
          this.policyForm.invoicePhoto2 = "";
        } else {
          this.policyForm.invoicePhoto1 = "";
        }
      }
    },
    handleUploadData(obj) {
      Object.keys(obj).forEach((key) => {
        if (
          key == "invoicePdf1" ||
          key == "invoicePdf2" ||
          key == "invoicePhoto1" ||
          key == "invoicePhoto2" ||
          key == "compulsoryInsurance" ||
          key == "commercialInsurance"
        ) {
          obj[key] = obj[key].substring(obj[key].lastIndexOf("/") + 1);
          obj["invoicePdf"] =
            this.subString(obj["invoicePdf1"]) + obj["invoicePdf1"]
              ? ","
              : "" + this.subString(obj["invoicePdf2"]);
          obj["invoicePhoto"] =
            this.subString(obj["invoicePhoto1"]) + obj["invoicePhoto1"]
              ? ","
              : "" + this.subString(obj["invoicePhoto2"]);
        }
      });
    },
    subString(str) {
      return str.substring(str.lastIndexOf("/") + 1);
    },
    // 提交上传
    saveUpload() {
      // // 如果不是pdf文件,删除上传
      // if (!/^data:application/.test(this.policyForm.compulsoryInsurance)) {
      //   this.policyForm.compulsoryInsurance = "";
      // }
      // if (!/^data:application/.test(this.policyForm.commercialInsurance)) {
      //   this.policyForm.commercialInsurance = "";
      // }
      // if (!/^data:application/.test(this.policyForm.invoicePdf)) {
      //   this.policyForm.invoicePdf = "";
      // }
      this.$refs.policyForm.validate(async (valid) => {
        if (valid) {
          /** 商业险时间和保单传了其中一个另一个必传判断 start */
          if (
            this.policyForm.businessDate &&
            !this.policyForm.commercialInsurance
          ) {
            return this.$message.warning("商业险保单不能为空！");
          }
          if (
            this.policyForm.commercialInsurance &&
            !this.policyForm.businessDate
          ) {
            return this.$message.warning("商业险生效日期不能为空！");
          }
          /** 商业险时间和保单传了其中一个另一个必传判断 end */
          // 处理提交上传的参数数据
          this.handleUploadData(this.policyForm);
          if (!this.policyForm.compulsoryInsurance && this.editorFlag) {
            return this.$message.warning("交强险保单不能为空！");
          }
          let { data: res } = await this.$axios.put(
            "/api/vehicle/insuranceManage",
            this.policyForm
          );
          if (res.code == 1) {
            if (this.editorFlag) {
              this.watchPolicyVisible = false;
            } else {
              this.policyVisible = false;
            }
            //信息提示
            this.$message.success("操作成功");
            //刷新表格【？？？在关闭弹框之前刷新表格数据会触发第二次form表单校验】
            this.getInsuranceList();
          } else {
            this.$message.warning(res.msg);
          }
        }
      });
    },
    // 更新保单【新增和编辑功能】
    updatePolicy(rowData) {
      // 清空文件数据
      Object.keys(this.policyForm).forEach((key) => {
        this.policyForm[key] = "";
      });
      this.policyForm.vin = rowData.vin;
      this.policyVisible = true;
    },
    // 更新保单弹框关闭回调
    cancelDialog() {
      this.policyVisible = false;
      this.$refs.policyForm.resetFields();
    },
    // 取消上传
    cancelUpload() {
      // 清除验证和文件数据
      this.$resetForm(this, "policyForm");
      this.policyVisible = false;
      if (this.editorFlag) this.editorFlag = false;
    },
    changeTime(val) {
      if (!val) return null;
      if (val >= 0 && val <= 30) {
        return "paixuOrange";
      } else if (val < 0) {
        return "paixuRed";
      }
    },
    // 保险到期剩余时间排序
    remainingTimeSort({ column, prop, order }) {
      console.log(column, prop);
      if (prop == "effectiveCountdown") {
        this.isPaixuBlue = true;
      } else {
        this.isPaixuBusiness = true;
      }
      if (order == "ascending") {
        // 升序排列
        if (prop == "effectiveCountdown") {
          this.top = true;
          this.queryForm.sort = 1;
        } else {
          this.businessTop = true;
        }
        this.getInsuranceList();
      }
      if (order === "descending") {
        // 降序排列（默认）
        if (prop == "effectiveCountdown") {
          this.top = false;
          this.queryForm.sort = 2;
        } else {
          this.businessTop = false;
        }
        this.getInsuranceList();
      }
      if (order == null) {
        if (prop == "effectiveCountdown") {
          this.isPaixuBlue = false;
        } else {
          this.isPaixuBusiness = false;
        }
      }
    },
    query() {
      this.getInsuranceList();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.getInsuranceList();
    },
    //查询行驶证
    async queryDriver(rowData) {
      if (rowData.personnelId) {
        let _this = this;
        // 清空行驶证数据
        _this.vehicleUrl = "";
        _this.mainPageUrl = "";
        _this.vicePageUrl = "";
        _this.vehicleUrlList = [];
        _this.mainPageUrlList = [];
        _this.vicePageUrlList = [];
        let { data: res } = await _this.$axios.get(
          "/api/vehicle/driving/" + rowData.personnelId
        );
        if (res.code == 1) {
          let arr = res.data;
          arr.forEach((item) => {
            if (item.belongType == 2) {
              // 筛选出行驶证的数据
              if (item.imageType == 2) {
                // 行驶证主页数据
                _this.mainPageUrl = item.url;
                _this.mainPageUrlList.push(_this.mainPageUrl);
              } else if (item.imageType == 1) {
                // 车辆照片页数据
                _this.vehicleUrl = item.url;
                _this.vehicleUrlList.push(_this.vehicleUrl);
              } else if (item.imageType == 3) {
                // 行驶证副页数据
                _this.vicePageUrl = item.url;
                _this.vicePageUrlList.push(_this.vicePageUrl);
              }
            }
          });
        } else {
          _this.$message.warning(res.msg);
        }
        _this.driverVisible = true;
      } else {
        this.$message.warning("未查询到数据！");
      }
    },
    // 获取保险公司列表数据
    async getCompanyList() {
      let { data: res } = await this.$axios.get(
        "/api/vehicle/insurance/company/list"
      );
      if (res.code == 1) {
        res.data.forEach((item) => {
          this.companyList.push({
            id: item.id,
            value: item.companyName,
          });
        });
      } else {
        this.$message.warning(res.msg);
      }
    },
    async getInsuranceList() {
      let obj = {};
      obj.vin = this.queryForm.vin;
      obj.sort = this.queryForm.sort;
      obj.plate = this.queryForm.plateNum;
      obj.companyName = this.queryForm.companyName;
      obj.personnelName = this.queryForm.personnelName;
      obj.propertyOwner = this.queryForm.propertyOwner;
      obj.page = this.currentPage;
      obj.limit = this.limit;
      let { data: res } = await this.$axios.get(
        "/api/vehicle/insuranceManage/pageList",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        this.tableData = res.data.list;
        // 表格数据根据保险剩余到期时间进行倒序排列
        res.data.list.sort(
          (a, b) => b.effectiveCountdown - a.effectiveCountdown
        );
        this.total = res.data.totalCount;
      } else {
        this.$message.warning(res.msg);
      }
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getInsuranceList();
    },
  },
};
</script>

<style lang="scss" scoped>
.insurancePolicyManagement-container {
  height: calc(100% - 60px);
  margin: 20px;
  padding: 20px 20px 0 20px;
  background: #fff;
  .paixuBlue {
    color: #0094ff;
  }
  ::v-deep .caret-wrapper {
    display: none !important;
  }
  .imgWrap {
    position: relative;
    max-width: 500px;
    max-height: 340px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .imgWrap img {
    width: auto;
    height: 280px;
  }
  .dialog-title {
    width: 100%;
    height: 20px;
    padding-left: 10px;
    margin-bottom: 10px;
    border-left: 4px solid #0093ff;
    font-size: 14px;
    font-weight: bold;
    color: #333;
    box-sizing: border-box;
  }
  .driverBody /deep/ {
    .errorImg {
      color: #ccc;
    }
    .el-dialog {
      padding-bottom: 20px;
    }
    .el-dialog__body {
      max-height: 800px;
      overflow-y: auto;
      img {
        width: 480px;
        height: 280px;
      }
    }
  }
  .policy-dialog {
    /deep/ .el-dialog {
      min-width: 880px;
      .el-dialog__body {
        max-height: 800px;
        overflow-y: auto;
      }
    }
    .policy-item {
      .trafficPdfUpload {
        /deep/ .el-form-item__label {
          text-align: left;
          height: 20px;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          font-weight: 600;
          border-left: 4px solid #0093ff;
          padding-left: 10px;
        }
        // /deep/ .el-form-item__label::before {
        //   display: inline-block;
        //   content: "";
        //   width: 4px;
        //   height: 20px;
        //   background: #0093ff;
        //   margin-right: 10px;
        // }
        /deep/ .el-form-item__content {
          width: 100%;
        }
      }
      .bill-file {
        display: flex;
        .policy-item {
          width: 40%;
          margin-right: 20px;
        }
      }
    }
    .text-red {
      font-weight: 400;
      color: #ff0000;
    }
    /deep/ .el-upload-list {
      display: none !important;
    }
    /deep/ .el-upload--picture-card {
      width: auto;
      height: auto;
      line-height: normal;
      border: none;
      background: #fff;
      color: #0093ff;
      margin-top: 5px;
      &:hover {
        text-decoration: underline;
      }
    }
    /deep/ .el-input__inner {
      padding-left: 15px;
    }
    /deep/ .el-input__prefix {
      left: auto;
      right: 10px;
      color: #0094ff;
    }
    /deep/.el-input__suffix {
      .el-input__icon.el-icon-circle-close {
        line-height: 32px;
        display: none;
      }
    }
  }
  .watch-policy-dialog {
    /deep/ .el-dialog {
      min-width: 880px;
      .el-dialog__body {
        max-height: 800px;
        overflow-y: auto;
        .modify {
          margin-bottom: 20px !important;
        }
      }
    }
    .watch-item {
      margin-top: 20px !important;
      .item-top {
        display: flex;
        flex-direction: column;
        .require::before {
          content: "*";
          color: #f56c6c;
          margin-right: 4px;
        }
      }
      .item-bottom {
        padding-top: 20px !important;
      }
    }
    .reset-upload {
      display: inline-block;
      margin-right: 20px !important;
      /deep/ .el-upload-list {
        display: none !important;
      }
      /deep/ .el-upload--picture-card {
        width: auto;
        height: auto;
        line-height: normal;
        border: none;
        background: #fff;
        color: #0093ff;
      }
      /deep/ .el-button {
        width: 100px !important;
      }
    }
  }

  .history-policy-dialog {
    /deep/ .el-dialog {
      min-width: 880px;
      .el-dialog__body {
        padding: 0;
        padding-top: 20px;
        .delete-button {
          margin-bottom: 20px;
        }
      }
    }
    /deep/ .el-tabs__content {
      padding: 20px;
      max-height: 800px;
      overflow-y: auto;
    }
    ::v-deep .el-tabs__nav-wrap {
      padding: 0 20px;
    }
  }
  .paixuOrange {
    color: #ff7b05;
  }
  .paixuRed {
    color: #f53929;
  }
  /deep/ .el-image {
    display: block;
    margin-bottom: 20px !important;
  }
}
</style>
